var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-fieldset"},[_c('div',{staticClass:"legend"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"w-100"},[_vm._t("default")],2),_c('div',{staticClass:"operation"},[_vm._t("operation")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }